import React from "react";
import type { Illustration } from "../util";
import { illustrationProps } from "../util";

export const DonationSuccess: Illustration = (props) => (
  <svg viewBox="0 0 162 98" {...illustrationProps(props, { width: 162 })}>
    <path
      d="M20.1657 29.6745L19.8565 31.1045L18.7212 30.1816C15.1737 27.2977 9.95824 28.3549 7.84983 32.3853C5.93838 36.0392 7.41442 40.6113 11.1034 42.4634L25.3697 49.6259C26.03 49.9574 26.8232 49.6789 27.1313 49.0074L33.7891 34.4987C35.5107 30.747 33.8047 26.2557 30.0287 24.5986C25.8635 22.7708 21.1318 25.2058 20.1657 29.6745Z"
      fill="white"
    />
    <path
      d="M137.372 30.4913L136.707 31.1208L136.447 30.2434C135.632 27.5017 132.565 26.207 130.053 27.5446C127.776 28.7573 126.925 31.6399 128.177 33.8986L133.018 42.6335C133.242 43.0378 133.75 43.1739 134.146 42.9358L142.706 37.7916C144.919 36.4614 145.623 33.5393 144.258 31.3506C142.751 28.9364 139.448 28.5241 137.372 30.4913Z"
      fill="white"
    />
    <path
      d="M35.7547 68.4636L35.6706 69.4475L34.8313 68.9273C32.2087 67.3016 28.8083 68.4575 27.7433 71.3367C26.7777 73.947 28.1587 76.8807 30.7873 77.8035L40.9529 81.3722C41.4234 81.5373 41.9304 81.2828 42.079 80.8068L45.289 70.5223C46.119 67.8629 44.5911 65.003 41.9209 64.2182C38.9756 63.3526 36.0174 65.3893 35.7547 68.4636Z"
      fill="white"
    />
    <path
      d="M133.998 65.1596L132.621 65.9061L132.579 64.3398C132.447 59.4456 127.949 55.9461 123.203 57.0451C118.901 58.0414 116.217 62.4304 117.286 66.7197L121.42 83.3072C121.611 84.075 122.391 84.5251 123.151 84.3069L139.584 79.5935C143.833 78.3747 146.292 73.8552 145.003 69.6313C143.582 64.9721 138.303 62.8268 133.998 65.1596Z"
      fill="#F8F6F3"
    />
    <path
      d="M83.0954 26.2699L80.9785 29.7181L78.8617 26.2699C72.2472 15.4953 57.6705 13.4761 48.477 22.061C40.1423 29.8439 39.8053 43.1257 47.7342 51.3376L78.397 83.0953C79.8162 84.5651 82.1409 84.5651 83.56 83.0953L114.223 51.3376C122.152 43.1257 121.815 29.8439 113.48 22.061C104.287 13.4761 89.7099 15.4953 83.0954 26.2699Z"
      fill="#76C82E"
    />
    <path
      d="M68.0591 50.7376L76.0263 58.9923L98.8203 36.229"
      stroke="white"
      strokeWidth="6.15224"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
